import {
    Box, Button, DialogActions, DialogContent, DialogContentText,
    Grid, Tab,
    TextField,
    Typography, useMediaQuery, useTheme
} from "@material-ui/core";
import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import './LoanDetails.css';
import {useEffect, useState} from "react";
import ChangeStatusLoan from "../ChangeStatusLoan/ChangeStatusLoan";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {LoansService} from "../../pages/LoinsList/LoansService";
import {
    convertCurrencyFormat,
    convertCurrencyFormatPositiveNegative,
    convertToBirthDate
} from "../../utils/numberConvertor";
import moment from "jalali-moment";
import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import NumberOfInstallmentsPaid from "../../assets/images/LoanDetails/NumberOfInstallmentsPaid.svg"
import NumberOfUnpaidInstallments from "../../assets/images/LoanDetails/NumberOfUnpaidInstallments.svg"
import NumberOfArrears from "../../assets/images/LoanDetails/NumberOfArrears.svg"
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {css} from "@emotion/css";
import {Alert, AlertTitle, TabContext, TabList, TabPanel} from "@material-ui/lab";
import ReportItems, {ReportsItemTypes} from "../reportItem/ReportItems";
import UploadReceiptImage from "../UploadReceiptImage/UploadReceiptImage";
import {RaikoMoneyInputOutlined} from "@moeindal/base-raiko-panel-components";

const LoanDetails = ({openDialog, handleClose, selectedLoanId, needRefresh}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new LoansService(fundID, token, snackbar, loading)


    const [loanId, setLoanId] = useState("");
    const [numberOfInstallments, setNumberOfInstallments] = useState("");
    const [amount, setAmount] = useState("");
    const [grantDate, setGrantDate] = useState("");
    const [amountOfCommission, setAmountOfCommission] = useState("");
    const [withdrawalAmountFromTheAccount, setWithdrawalAmountFromTheAccount] = useState("");
    const [loanKind, setLoanKind] = useState("");
    const [paymentMaturity, setPaymentMaturity] = useState("");
    const [createdBy, setCreatedBy] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [groupName, setGroupName] = useState("");
    const [balance, setBalance] = useState("");

    const [bankAccountNumber, setBankAccountNumber] = useState("");
    const [IBAN, setIBAN] = useState("");


    const [receiptUrl, setReceiptUrl] = useState("");
    const [installmentsList, setInstallmentsList] = useState([]);

    const [numberOfDeferredInstallments, setNumberOfDeferredInstallments] = useState(0);
    const [summationOfDeferredInstallment, setSummationOfDeferredInstallment] = useState(0);

    const [numberOfPaidInstallments, setNumberOfPaidInstallments] = useState(0);
    const [summationOfPaidInstallments, setSummationOfPaidInstallments] = useState(0);

    const [numberOfUnpaidInstallments, setNumberOfUnpaidInstallments] = useState(0);
    const [summationOfUnpaidInstallments, setSummationOfUnpaidInstallments] = useState(0);


    const [openDialogLoan, setOpenDialogLoan] = useState(false);

    const handleCloseDialog = () => {
        setOpenDialogLoan(false);
    };

    function clearFields() {

        setLoanId("")
        setNumberOfInstallments("")
        setAmount("")
        setGrantDate("")
        setAmountOfCommission("")
        setWithdrawalAmountFromTheAccount("")
        setLoanKind("")
        setPaymentMaturity("")
        setCreatedBy("")
        setFirstName("")
        setLastName("")
        setNationalCode("")
        setGroupName("")
        setBalance("")
        setBankAccountNumber("")
        setIBAN("")


        setReceiptUrl("")
        setInstallmentsList([])

        setSelectedTab(tabType.INFO)

        setImageFile(null)
        setImage("")
        setHideImageUploadLoading(true)
        setProgressImage(0)
        setBufferImage(5)

    }

    const handleClickOpenDialog = () => {
        setOpenDialogLoan(true);
    };

    useEffect(() => {
        if (selectedLoanId >= 0) {
            clearFields()
            getLoanInfo()
        }
    }, [selectedLoanId])

    function getLoanInfo() {
        loading(setLoadingStateDispatch(true))
        service.getLoanDetail(fundID, selectedLoanId)
            .then(({loanStatusResponse, loanDetailResponse}) => {

                setNumberOfPaidInstallments(loanStatusResponse.numberOfPaidInstallments)
                setSummationOfPaidInstallments(loanStatusResponse.summationOfPaidInstallments)

                setNumberOfDeferredInstallments(loanStatusResponse.numberOfDeferredInstallments)
                setSummationOfDeferredInstallment(loanStatusResponse.summationOfDeferredInstallment)

                setNumberOfUnpaidInstallments(loanStatusResponse.numberOfUnpaidInstallments)
                setSummationOfUnpaidInstallments(loanStatusResponse.summationOfUnpaidInstallments)


                setLoanId(loanDetailResponse.id)
                setNumberOfInstallments(loanDetailResponse.numberOfInstallments)
                setAmount(loanDetailResponse.amount)
                setGrantDate(loanDetailResponse.grantDate)
                setAmountOfCommission(loanDetailResponse.amountOfCommission)
                setWithdrawalAmountFromTheAccount(loanDetailResponse.withdrawalAmountFromTheAccount)
                setLoanKind(loanDetailResponse.loanKind)
                setPaymentMaturity(loanDetailResponse.paymentMaturity)
                setCreatedBy(loanDetailResponse.createdBy)
                setFirstName(loanDetailResponse.firstName)
                setLastName(loanDetailResponse.lastName)
                setNationalCode(loanDetailResponse.nationalCode)
                setGroupName(loanDetailResponse.groupName)
                setBalance(loanDetailResponse.balance)
                setBankAccountNumber(loanDetailResponse.bankAccountNumber)
                setIBAN(loanDetailResponse.IBAN)


                setInstallmentsList(loanDetailResponse.installments)
                setReceiptUrl(loanDetailResponse.receiptUrl)

                console.log("loanDetailResponse is : ", loanDetailResponse)
                console.log("receipt is ", receiptUrl)


                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت جزئیات وام", snackbar, loading)
        })
    }

    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });


    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });


    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const [openHandleDeleteDialog, setOpenHandleDeleteDialog] = React.useState(false);


    const handleClickOpenDeleteLoanDialog = () => {
        setOpenHandleDeleteDialog(true);
    };

    const handleCloseDeleteLoinDialog = () => {
        setOpenHandleDeleteDialog(false);
    };

    const [deleteConfirm, setDeleteConfirm] = useState("");

    function doDeleteLoin() {
        if (deleteConfirm === "delete") {
            loading(setLoadingStateDispatch(true))
            needRefresh(true)
            handleCloseDeleteLoinDialog()

            service.deleteLoin(fundID, selectedLoanId)
                .then(response => {
                    snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "وام با موفقیت حذف شد"))
                    loading(setLoadingStateDispatch(false))
                    handleClose()
                }).catch(reason => {
                ServerErrorHandler(reason, "خطا در حذف وام!", snackbar, loading)
            })
        } else {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "لطفا کلمه delete را به درستی وارد نمایید"))
        }
    }

    const [selectedTab, setSelectedTab] = useState(tabType.INFO);

    function handleTabChange(e, newValue) {
        setSelectedTab(newValue)
    }

    const [imageFile, setImageFile] = useState(null);
    const [imageName, setImageName] = useState("لطفا تصویر مورد نظر را انتخاب نمایید !");
    const [image, setImage] = useState("");
    const [hideImageUploadLoading, setHideImageUploadLoading] = useState(true)
    const [progressImage, setProgressImage] = useState(0)
    const [bufferImage, setBufferImage] = useState(5)


    function doUploadFile() {
        loading(setLoadingStateDispatch(true))
        service.doUploadFile(selectedLoanId, imageFile, setHideImageUploadLoading, setProgressImage, setBufferImage)
            .then(response => {
                loading(setLoadingStateDispatch(false))
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "فایل رسید با موفقیت بارگزاری شد."))
            }).catch(reason => {
            loading(setLoadingStateDispatch(false))
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در بارگزاری فایل رسید!"))
        })
    }

    return (
        <>
            {
                <ChangeStatusLoan
                    openDialogLoan={openDialogLoan}
                    handleCloseDialog={handleCloseDialog}
                    handleClickOpenDialog={handleClickOpenDialog}
                />
            }

            <Dialog fullScreen onClose={handleClose} aria-labelledby="customized-dialog-title" open={openDialog}
                    id="customized-full-screen-dialog">
                <DialogTitle id="customized-dialog-title">
                    <section className="d-flex flex-row flex-nowrap" style={{gap: "16px", padding: "0 1rem"}}>
                        <span className="flex-grow-1"> جزئیات وام</span>
                        <Button className="btn-secondary me-2 " onClick={handleClose}>
                            بازگشت
                        </Button>
                    </section>
                </DialogTitle>
                <section className={css`display: flex;
                  flex-direction: column;
                  width: 100%;
                  padding: 0 1rem`}>

                    <TabContext value={selectedTab}>
                        <TabList onChange={handleTabChange} id={"default-tab-container"}>
                            <Tab label={"جزئیات وام"} value={tabType.INFO}/>
                            <Tab label={"رسید وام"} value={tabType.RECEIPT}/>
                            <Tab label={"گزارشات"} value={tabType.REPORTS}/>
                            <Tab label={"حذف وام"} value={tabType.DELETE_LOAN}/>
                        </TabList>
                        <TabPanel value={tabType.INFO}>
                            <Box className="loan-details-main-box">
                                <section className="ViewLoanDetailsContainer  hideScrollBar hideScroll">
                                    <div className="loanDetails">
                                        <div className="accountDetailsWrapper">
                                            <p>
                                                {`${numberOfPaidInstallments} قسط پرداخت شده`}
                                            </p>
                                            <span className="fs-3 font_primary_bold">
                                        {`${convertCurrencyFormat(summationOfPaidInstallments)} ریال `}
                                    </span>
                                        </div>
                                        <img src={NumberOfInstallmentsPaid} alt="NumberOfInstallmentsPaid"/>
                                    </div>
                                    <div className="loanDetails">
                                        <div className="accountDetailsWrapper">
                                            <p>
                                                {`${numberOfUnpaidInstallments} قسط پرداخت نشده`}
                                            </p>
                                            <span className="fs-3 font_primary_bold">
                                       {`${convertCurrencyFormat(summationOfUnpaidInstallments)} ریال `}
                                    </span>
                                        </div>
                                        <img src={NumberOfUnpaidInstallments} alt="NumberOfUnpaidInstallments"/>
                                    </div>
                                    <div className="loanDetails">
                                        <div className="accountDetailsWrapper">
                                            <p>
                                                {`${numberOfDeferredInstallments} قسط پرداخت معوقه`}
                                            </p>
                                            <span className="fs-3 font_primary_bold">
                                       {`${convertCurrencyFormat(summationOfDeferredInstallment)} ریال `}
                                    </span>
                                        </div>
                                        <img src={NumberOfArrears} alt="NumberOfArrears"/>
                                    </div>

                                </section>
                                <Box className="w-100" sm={12}>
                                    <Grid className='d-flex flex-row flex-wrap flex-grow-1 w-100' sm={12}
                                          style={{marginTop: '1rem'}}>
                                        <Grid sm={6} md={4} lg={3} xl={3} className='p-2 w-100'>
                                            <TextField
                                                value={loanId}
                                                className='w-100'
                                                variant="outlined"
                                                disabled={true}
                                                label="شناسه درخواست"/>
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={3} className='p-2 w-100'>
                                            <TextField
                                                value={`${firstName} ${lastName}`}
                                                className='w-100'
                                                variant="outlined"
                                                disabled={true}
                                                label="نام و نام خانوادگی"/>
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={3} className='p-2 w-100'>
                                            <TextField
                                                value={nationalCode}
                                                className='w-100'
                                                variant="outlined"
                                                disabled={true}
                                                label="کد ملی"/>
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={3} className='p-2 w-100'>
                                            <RaikoMoneyInputOutlined
                                                labelText={"مبلغ وام (ریال)"}
                                                setValue={_=>{}}
                                                className='w-100'
                                                variant="outlined"
                                                disabled={true}
                                                value={amount}
                                                label="مبلغ وام (ریال)"
                                            />
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={3} className='p-2 w-100'>
                                            <TextField
                                                className='w-100'
                                                variant="outlined"
                                                disabled={true}
                                                value={grantDate ? convertToBirthDate(
                                                    moment(grantDate, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')) : "-"}
                                                label="تاریخ پرداخت"/>
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={3} className='p-2 w-100'>
                                            <RaikoMoneyInputOutlined
                                                labelText={"مبلغ وام (ریال)"}
                                                setValue={_=>{}}
                                                className='w-100'
                                                variant="outlined"
                                                disabled={true}
                                                value={amountOfCommission}
                                                label="کمیسیون (ریال)"/>
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={3} className='p-2 w-100'>
                                            <RaikoMoneyInputOutlined
                                                labelText={"مبلغ کسر شده از موجودی (ریال)"}
                                                setValue={_=>{}}
                                                className='w-100'
                                                variant="outlined"
                                                disabled={true}
                                                value={withdrawalAmountFromTheAccount}
                                                />
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={3} className='p-2 w-100'>
                                            <TextField
                                                className='w-100'
                                                variant="outlined"
                                                disabled={true}
                                                value={loanKind}
                                                label="نوع وام"/>
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={3} className='p-2 w-100'>
                                            <TextField
                                                className='w-100'
                                                variant="outlined"
                                                disabled={true}
                                                value={paymentMaturity ? convertToBirthDate(
                                                    moment(paymentMaturity, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')) : "-"}
                                                label="تاریخ سررسید"/>
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={3} className='p-2 w-100'>
                                            <TextField
                                                className='w-100'
                                                variant="outlined"
                                                disabled={true}
                                                value={createdBy}
                                                label="سازنده"/>
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={3} className='p-2 w-100'>
                                            <TextField
                                                className='w-100'
                                                variant="outlined"
                                                disabled={true}
                                                value={groupName}
                                                label="گروه"/>
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={3} className='p-2 w-100'>
                                            <RaikoMoneyInputOutlined
                                                labelText={"موجودی کل"}
                                                setValue={_=>{}}
                                                className='w-100'
                                                variant="outlined"
                                                disabled={true}
                                                value={balance}
                                                label="موجودی کل"/>
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={3} className='p-2 w-100'>
                                            <TextField
                                                className='w-100'
                                                variant="outlined"
                                                disabled={true}
                                                value={bankAccountNumber}
                                                label="شماره حساب"/>
                                        </Grid>
                                        <Grid sm={6} md={8} lg={9} xl={9} className='p-2 w-100'>
                                            <TextField
                                                className='w-100'
                                                variant="outlined"
                                                disabled={true}
                                                value={IBAN}
                                                label="شماره شبا"/>
                                        </Grid>

                                    </Grid>
                                </Box>
                                {installmentsList.length > 0 ?
                                    <Box className="BorderBox mt-3">
                                        <Box className="d-flex flex-column">
                          <span className="titleOfOBorderBox">
                        اقساط وام
                          </span>
                                            {numberOfInstallments > 0 ?
                                                <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                                                    {" " + numberOfInstallments + " قسط"}
                                                </Typography> :
                                                ''}

                                        </Box>
                                    </Box> : ""}
                                <Box className="d-flex flex-column">
                                    {
                                        installmentsList.map((item, index) => {
                                            return <Box className="cardCustom">
                                                <Grid xs={6} sm={4} md={3} lg={1} xl={1}
                                                      className="cardCustomContent p-2 w-100">
                                                    <span className="cardCustomTitle">#</span>
                                                    <span className="cardCustomDescription">{index + 1}</span>
                                                </Grid>
                                                <Grid xs={6} sm={4} md={3} lg={1} xl={1}
                                                      className="cardCustomContent p-2 w-100">
                                                    <span className="cardCustomTitle">شماره قسط</span>
                                                    <span className="cardCustomDescription">{item.id}</span>
                                                </Grid>
                                                <Grid xs={6} sm={4} md={3} lg={2} xl={2}
                                                      className="cardCustomContent p-2 w-100">
                                                    <span className="cardCustomTitle">سررسید</span>
                                                    <span
                                                        className="cardCustomDescription">{convertToBirthDate(moment(item.dateOfPayment, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD'))}</span>
                                                </Grid>
                                                <Grid xs={6} sm={4} md={3} lg={2} xl={2}
                                                      className="cardCustomContent p-2 w-100">
                                                    <span className="cardCustomTitle">مبلغ (ریال)</span>
                                                    <span
                                                        className="cardCustomDescription">{convertCurrencyFormat(item.amountPayable)}</span>
                                                </Grid>
                                                <Grid xs={6} sm={4} md={3} lg={2} xl={2}
                                                      className="cardCustomContent p-2 w-100">
                                                    <span className="cardCustomTitle">مبلغ پرداخت شده (ریال)</span>
                                                    <span
                                                        className="cardCustomDescription">{convertCurrencyFormat(item.amountPaid)}</span>
                                                </Grid>
                                                <Grid xs={6} sm={4} md={3} lg={1} xl={1}
                                                      className="cardCustomContent p-2 w-100">
                                                    <span className="cardCustomTitle">تاریخ پرداخت</span>
                                                    <span
                                                        className="cardCustomDescription">{
                                                        item.paidAt ? convertToBirthDate(
                                                            moment(item.paidAt, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')) : "-"}</span>
                                                </Grid>
                                                <Grid xs={6} sm={4} md={3} lg={2} xl={2}
                                                      className="cardCustomContent p-2 w-100">
                                                    <span className="cardCustomTitle">پرداخت کننده</span>
                                                    <span
                                                        className="cardCustomDescription">{
                                                        item.paidByManger ?
                                                            item.paidByManger :
                                                            item.paidByMember ? item.paidByMember : "ندارد"}</span>
                                                </Grid>
                                                <Grid xs={6} sm={4} md={3} lg={1} xl={1}
                                                      className="cardCustomContent p-2 w-100">
                                                    <span className="cardCustomTitle">وضعیت</span>
                                                    {item.paid ?
                                                        <span
                                                            className="cardCustomDescription bg_active_state">پرداخت شده</span>
                                                        : <span
                                                            className="cardCustomDescription bg_deActive_state">پرداخت نشده</span>
                                                    }
                                                </Grid>
                                            </Box>
                                        })
                                    }

                                </Box>
                            </Box>
                        </TabPanel>
                        <TabPanel value={tabType.RECEIPT}>
                            <div className={css`
                              display: flex;
                              flex-direction: column`}>
                                <UploadReceiptImage
                                    loanId={selectedLoanId}
                                    bufferImage={bufferImage}
                                    hideImageUploadLoading={hideImageUploadLoading}
                                    progressImage={progressImage}
                                    setImage={setImage}
                                    setImageFile={setImageFile}
                                    setImageName={setImageName}
                                    image={image}
                                    receiptUrl={receiptUrl}
                                />
                                <div className={css`
                                  display: flex;
                                  width: 100%;
                                  justify-content: flex-end;
                                  margin-top: 1rem`}>
                                    <button className="btn-confirm" onClick={doUploadFile}>
                                        تایید
                                    </button>
                                </div>
                            </div>

                        </TabPanel>
                        <TabPanel value={tabType.REPORTS}>
                            <section className={css`
                              margin-top: 1rem;
                              gap: 16px;
                              display: flex;
                              flex-direction: column;
                            `}>
                                <ReportItems
                                    title={"دریافت گزارش وضعیت وام"}
                                    downloadExcel={_ => {
                                        service.downloadLoanReports(selectedLoanId, ReportsItemTypes.XLSX)
                                    }}
                                    downloadPdf={_ => {
                                        service.downloadLoanReports(selectedLoanId, ReportsItemTypes.PDF)
                                    }}
                                />
                            </section>
                        </TabPanel>

                        <TabPanel value={tabType.DELETE_LOAN}>
                            <section className={css`
                              margin-top: 1rem;
                              gap: 16px;
                              display: flex;
                              flex-direction: column;
                            `}>

                                <Alert severity="warning" className={`warning-alert`}>
                                    <AlertTitle>آیا از حذف وام اطمینان دارید؟</AlertTitle>
                                    <div className={css`display: flex;
                                      flex-direction: column;
                                      gap: 8px;
                                      margin-top: 16px;
                                    `}>
                                        <span>با حذف وام امکان بازگشت آن وجود نخواهد داشت!</span>
                                        <span>برای تایید حذف وام لطفا کلمه <strong>delete</strong> را در کارد زیر وارد کرده و سپس تایید نمایید.</span>
                                    </div>
                                </Alert>
                                <Grid sm={12} md={12} lg={12} xl={12} className='w-100'>
                                    <TextField value={deleteConfirm}
                                               onChange={e => {
                                                   setDeleteConfirm(e.target.value)
                                               }}
                                               className='w-100'
                                               variant="outlined"
                                               placeholder={"delete"}
                                               label="تایید حذف وام"/>
                                </Grid>
                                <div className={css`display: flex;
                                  flex-direction: row;
                                  justify-content: end; `}>
                                    <button onClick={doDeleteLoin} className={"btn-confirm"}>تایید</button>
                                </div>
                            </section>
                        </TabPanel>
                    </TabContext>


                </section>


            </Dialog>
        </>


    )
}
export default LoanDetails;

const tabType = {
    INFO: "INFO",
    RECEIPT: "RECEIPT",
    REPORTS: "REPORTS",
    DELETE_LOAN: "DELETE_LOAN",
}
